import {Action} from '@ngrx/store';
import {IPaymentMethodState} from '../state/payment-method.state';

export enum PAYMENT_METHOD_ACTION {
  INIT_PAYMENT_METHOD = 'INIT_PAYMENT_METHOD',
  DELETE_PAYMENT_METHOD = 'DELETE_PAYMENT_METHOD',
  RESET_PAYMENT_METHOD = 'RESET_PAYMENT_METHOD',
}
export class SetPaymentMethod implements Action {
  readonly type = PAYMENT_METHOD_ACTION.INIT_PAYMENT_METHOD;

  constructor(public payload: IPaymentMethodState) {}
}
// eslint-disable-next-line max-classes-per-file
export class DeletePaymentMethod implements Action {
  readonly type = PAYMENT_METHOD_ACTION.DELETE_PAYMENT_METHOD;
}

// eslint-disable-next-line max-classes-per-file
export class ResetPaymentMethodStore implements Action {
  readonly type = PAYMENT_METHOD_ACTION.RESET_PAYMENT_METHOD;
}
export type PaymentMethodAction = SetPaymentMethod | DeletePaymentMethod | ResetPaymentMethodStore;
